<template>
    <div class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small text-uppercase bg-body text-muted">
                                <tr>
                                    <th class="align-middle">Nom</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="profile in profiles"
                                    :key="profile.id">
                                    <td v-if="profile.updating">
                                        <input v-model="profile.name" type="text" class="form-control" placeholder="Nom">
                                    </td>
                                    <td v-else-if="this.selectedId != profile.id"
                                        class="badge-row"
                                        @click="this.select(profile.id)">
                                        {{ profile.name }}
                                    </td>
                                    <td v-else
                                        class="selected-row">
                                        {{ profile.name }}
                                    </td>
                                    <td v-if="profile.updating" class="text-end">
                                        <ButtonDisplay
                                        :type="'save'"
                                        @click="this.save(profile); profile.updating = false; this.updatingName = false" />
                                        <ButtonDisplay
                                        :type="'cancel'"
                                        @click="profile.updating = false; this.updatingName = false" />
                                    </td>
                                    <td v-else class="text-end">
                                        <div class="me-4">
                                            <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                                                <font-awesome-icon :icon="['fas', 'bars']"/>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-end" style="">
                                                <a role="button" v-on:click="if(!this.updatingName) {profile.updating = true; this.updatingName = true}" class="dropdown-item">Modifier</a>
                                                <a role="button" v-on:click="this.delete(profile.id)" class="dropdown-item">Supprimer</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonDisplay from '../../../components/display/ButtonDisplay.vue'


export default {
    props: ['profiles', 'selectedId'],
    components: {
        ButtonDisplay
    },
    data() {
        return {
            updatingName: false
        };
    },
    methods: {
        select(id) {
            this.$emit("select", id);
        },
        delete(id) {
            this.$emit("deleteProfile", id);
        },
        save(profile) {
            this.$emit("saveProfile", profile.id, profile.name);
        }
    }
}
</script>

<style>
.badge-row:hover {
    background-color: #0dcaf0;
}

.selected-row {
    background-color: #0d6efd !important;
    color: #fff !important;
}
</style>